<template>
    <SearchBooking
        ref="searchBooking"
        class="p-10"
        type="guest" />
</template>

<script setup lang="ts">
import SearchBooking from '../../components/search-booking/index.vue'
const searchBooking = ref()
</script>
